export default __webpack_public_path__ + "static/media/signs.17ea90ee.svg";